import CustomComponent from "../../components/customComponent";
import { withRouter } from "../../components/withRouter";
import hoistStatics from "hoist-non-react-statics";
import moment from "moment";
import "moment/min/locales";
import { withTranslation } from "react-i18next";
import { withToast } from "../../App";
import { BoaterLayout } from "../../components/Layouts";
import ClockIcon from "../../assets/img/icons/clock.svg";
import ClockCheckmarkIcon from "../../assets/img/icons/clock-checkmark.svg";
import ChargeelectricityIcon from "../../assets/img/icons/charge-electricity.svg";
import ChargeWaterIcon from "../../assets/img/icons/charge-water.svg";
import HourGlassIcon from "../../assets/img/icons/hourglass.svg";
import MailNotificationIcon from "../../assets/img/icons/mail-notification.svg";
import LighbulbInfoAltIcon from "../../assets/img/icons/lightbulb-info-alt.svg";
import CongratulationsIcon from "../../assets/img/icons/congratulations.svg";
import StepDoneIcon from "../../assets/img/icons/step-done-bee.svg";
import { withBoaterStorage } from "../../hooks/useBoaterStorage";
import ChargingControlModal from "../../components/ChargingControlModal";

moment.locale("fr");

class BoaterTransaction extends CustomComponent {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            role: null,
            energy: null,
            terminal: null,
            connector: null,
            transaction: {},
            token: null,
            email: null,
            isModalOpen: false,
            isToggleOn: true,
            terminalId: null,
            terminalName: null,
        };
    }

    setupComponent() {
        if (this.checkIsConnectedPWA()) {
            this.setState({ role: this.loadRoles() });
        }

        this.setState({ loading: true });

        const { match, location } = this.props;
        const { energy, transaction_id } = match.params;

        const queryParams = new URLSearchParams(location.search);
        const token = queryParams.get("token");
        const email = queryParams.get("email");

        this.setState({
            energy,
            token,
            email,
        });

        this.updateTransaction(transaction_id, email, token);

        if (this._refreshInterval) clearInterval(this._refreshInterval);

        const emailParam = email;
        const tokenParam = token;

        this._refreshInterval = setInterval(
            () =>
                this.updateTransaction(transaction_id, emailParam, tokenParam),
            5000,
        );

        this.props.updateBoaterStorage({
            boater_return_to_modal: false,
        });
    }

    componentDidMount() {
        this._isMounted = true;
        this.setupComponent();
    }

    updateTransaction = async (transaction_id, emailParam, tokenParam) => {
        const email = emailParam || this.state.email;
        const token = tokenParam || this.state.token;

        let queryString = "";
        if (email) queryString += `email=${encodeURIComponent(email)}`;
        if (token) {
            if (queryString) queryString += "&";
            queryString += `token=${encodeURIComponent(token)}`;
        }

        try {
            const data = await this.request(
                `/transactions/${transaction_id}${
                    queryString ? `?${queryString}` : ""
                }`,
                "GET",
                "",
                false,
                "",
                false,
                {
                    isHandlingError: (data, httpStatus) =>
                        httpStatus === 403 &&
                        data.message === "Session expired or invalid",
                    handleError: () => {
                        this.props.navigate("/boater");
                    },
                },
            );

            if (data && data.status === "ok" && this._isMounted) {
                const transaction = data.transaction;

                const fluidType = transaction.fluidType
                    ? transaction.fluidType
                    : "";
                const isElectricity = fluidType === "Electricity";

                const consumed = transaction.consumed || 0;

                const formattedConsumed = consumed.toLocaleString("fr-FR", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                });

                let price = transaction.amount;
                if (typeof price === "string") {
                    price = parseFloat(price);
                }

                const formattedPrice = (price || 0).toLocaleString("fr-FR", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                });

                const energy = isElectricity ? "Electricity" : "water";

                this.setState({
                    transaction: {
                        ...transaction,
                        consumed: formattedConsumed,
                        price: formattedPrice,
                    },
                    energy: energy,
                    loading: false,
                });
            } else if (
                data &&
                data.status === "error" &&
                data.message === "Transaction not found"
            ) {
                this.setState({ loading: false });
                this.props.navigate("/boater");
            }
        } catch {
            this.setState({ loading: false });
        }
    };

    onEmailResend = async (e) => {
        e.preventDefault();
        const { t, addToast } = this.props;
        const { match } = this.props;
        const { transaction_id } = match.params;

        const data = await this.request(
            `/transactions/resend-email/${transaction_id}`,
            "POST",
            "",
            false,
            "/transactions/csrf",
        );
        if (data && data.status && data.status === "ok") {
            addToast(t("boater_consumption_email_resent"), {
                appearance: "success",
                autoDismiss: true,
            });
        }
    };

    componentWillUnmount() {
        this._isMounted = false;
        if (this._refreshInterval) clearInterval(this._refreshInterval);
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.params.transaction_id !== this.props.params.transaction_id
        ) {
            if (this._refreshInterval) clearInterval(this._refreshInterval);
            this.setupComponent();
        }

        if (prevProps.location.search !== this.props.location.search) {
            const queryParams = new URLSearchParams(this.props.location.search);
            const token = queryParams.get("token");
            const email = queryParams.get("email");

            this.setState({ token, email });

            const { transaction_id } = this.props.params;
            this.updateTransaction(transaction_id, email, token);
        }
    }

    getDefaultConnectorLabel = (transaction) => {
        const { t } = this.props;
        if (!transaction) return "--";

        const fluidType = transaction.fluidType || "";
        const position = transaction.position || "";

        return `${
            fluidType === "Electricity" ? t("Electricity") : t("Water")
        }-${position}`;
    };

    handleModalOpen = () => {
        const { transaction, energy } = this.state;
        const { match } = this.props;
        const { transaction_id } = match.params;

        this.props.updateBoaterStorage({
            currentTransactionId: transaction_id,
            currentTransactionType: transaction.fluidType || energy,
            connectorId: transaction.connectorId,
        });

        this.setState({ isModalOpen: true });
    };

    handleModalClose = () => {
        this.setState({ isModalOpen: false });
    };

    handleToggle = (state) => {
        this.setState({ isToggleOn: state });
    };

    handleStopCharge = () => {
        this.props.navigate("/boater/stop-charge");
    };

    handleAlsoStartClick = (e) => {
        e.preventDefault();

        const { transaction } = this.state;

        this.props.updateBoaterStorage({
            terminalId: transaction.terminalId,
            terminalName: transaction.cpoTerminalId,
            boater_return_to_modal: true,
        });

        this.props.navigate("/boater/step1");
    };

    render() {
        const { t } = this.props;
        const { energy, transaction, isModalOpen, isToggleOn } = this.state;

        const isFinished =
            transaction.status === "Stopping" ||
            transaction.status === "Finished";
        const isCharging =
            transaction.status === "Charging" || transaction.status === null;
        const showAlsoChargeButton =
            isCharging && transaction.hasOtherConnectorAvailable === 1;

        const connectorLabel =
            transaction?.connectorLabel &&
            transaction.connectorLabel.trim().length > 0
                ? transaction.connectorLabel
                : this.getDefaultConnectorLabel(transaction);

        return (
            <BoaterLayout
                step={4}
                blueBackground
                terminalName={transaction?.cpoTerminalId || ""}
                loading={this.state.loading}
            >
                <div className="consumption">
                    <h2 className="consumption__title">
                        {isFinished ? (
                            <>
                                <img src={ClockCheckmarkIcon} alt="" />
                                {t("boater_consumption_loading_end")}
                            </>
                        ) : (
                            <>
                                <img src={ClockIcon} alt="" />
                                {t("boater_consumption_followup")}
                            </>
                        )}
                    </h2>
                    <div className="consumption-card">
                        <div className="consumption-card__status">
                            {isFinished && (
                                <h3 className="consumption-card__status-title">
                                    <img
                                        src={CongratulationsIcon}
                                        alt=""
                                        width="58"
                                        height="64"
                                    />
                                    <span>
                                        {t(
                                            "boater_consumption_transaction_end",
                                        )}
                                    </span>
                                </h3>
                            )}
                            {isFinished && (
                                <div className="consumption-card__status-intro">
                                    <img
                                        className="consumption-card__status-icon"
                                        src={StepDoneIcon}
                                        alt=""
                                    />
                                    <p>
                                        {energy === "Electricity"
                                            ? t(
                                                  "boater_consumption_electric_disconnected",
                                              )
                                            : t(
                                                  "boater_consumption_water_disconnected",
                                              )}
                                    </p>
                                </div>
                            )}
                            {isCharging && (
                                <div className="consumption-card__status-intro">
                                    <img
                                        className="consumption-card__status-icon"
                                        src={HourGlassIcon}
                                        alt=""
                                    />
                                    <p>
                                        {energy === "Electricity"
                                            ? t(
                                                  "boater_consumption_electric_loading",
                                              )
                                            : t(
                                                  "boater_consumption_water_loading",
                                              )}
                                    </p>
                                </div>
                            )}
                            <img
                                className="consumption-card__status-icon consumption-card__status-icon--energy"
                                src={
                                    energy === "Electricity"
                                        ? ChargeelectricityIcon
                                        : ChargeWaterIcon
                                }
                                alt=""
                            />
                        </div>
                        <div className="consumption-card__body">
                            <ul className="consumption-card__consumption">
                                <li>
                                    <span className="strong">
                                        {transaction?.consumed || "--"}
                                    </span>
                                    <span
                                        dangerouslySetInnerHTML={{
                                            __html:
                                                energy === "Electricity"
                                                    ? t(
                                                          "boater_consumption_kwh",
                                                      )
                                                    : t(
                                                          "boater_consumption_m3",
                                                      ),
                                        }}
                                    ></span>
                                </li>
                                <li>
                                    <span className="strong">
                                        {transaction?.price || "--"}
                                    </span>
                                    euros
                                </li>
                            </ul>
                            {isCharging && (
                                <div className="cta-wrapper cta-wrapper--center">
                                    <button
                                        className="cta cta--large-padding"
                                        onClick={this.handleModalOpen}
                                    >
                                        <i className="cta__icon vnf-icons-icon-m-restrictions-outline"></i>
                                        {t("boater_consumption_stop")}
                                    </button>
                                </div>
                            )}
                            <hr />
                            <ul className="consumption-card__info">
                                <li>
                                    <span>{t("terminal")}</span>{" "}
                                    {transaction?.cpoTerminalId || "--"}
                                </li>
                                <li>
                                    <span>{t("charging_point")}</span>{" "}
                                    {connectorLabel}
                                </li>
                            </ul>
                            <hr />
                            <div className="consumption-card__notification">
                                <img
                                    className="consumption-card__notification-icon"
                                    src={MailNotificationIcon}
                                    alt=""
                                />
                                <div>
                                    {isCharging && (
                                        <p
                                            className="consumption-card__notification-intro"
                                            dangerouslySetInnerHTML={{
                                                __html: t(
                                                    "boater_consumption_email_info_loading",
                                                ),
                                            }}
                                        ></p>
                                    )}
                                    {isFinished && (
                                        <p
                                            className="consumption-card__notification-intro"
                                            dangerouslySetInnerHTML={{
                                                __html: t(
                                                    "boater_consumption_email_info_transaction",
                                                    {
                                                        value:
                                                            transaction?.price ||
                                                            "--",
                                                    },
                                                ),
                                            }}
                                        ></p>
                                    )}

                                    <p className="consumption-card__notification-cta">
                                        {t("boater_consumption_no_email")}
                                        <button
                                            onClick={this.onEmailResend}
                                            className="consumption-card__notification-link"
                                        >
                                            {t(
                                                "boater_consumption_resend_email",
                                            )}
                                        </button>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {isCharging && (
                        <>
                            {showAlsoChargeButton && (
                                <div className="consumption__also-charge">
                                    <img src={LighbulbInfoAltIcon} alt="" />

                                    {energy === "Electricity" ? (
                                        <button
                                            onClick={this.handleAlsoStartClick}
                                            className="cta cta--white cta--big"
                                        >
                                            {t(
                                                "boater_consumption_also_start_water",
                                            )}
                                            <img
                                                className="cta__image"
                                                src={ChargeWaterIcon}
                                                alt=""
                                            />
                                        </button>
                                    ) : (
                                        <button
                                            onClick={this.handleAlsoStartClick}
                                            className="cta cta--white cta--big"
                                        >
                                            {t(
                                                "boater_consumption_also_start_electricity",
                                            )}
                                            <img
                                                className="cta__image"
                                                src={ChargeelectricityIcon}
                                                alt=""
                                            />
                                        </button>
                                    )}
                                </div>
                            )}
                            <ChargingControlModal
                                isOpen={isModalOpen}
                                onClose={this.handleModalClose}
                                chargeAction="stop"
                                isToggleOn={isToggleOn}
                                onToggle={this.handleToggle}
                                onNext={this.handleStopCharge}
                                connectorLabel={connectorLabel}
                                connectorStatus={
                                    transaction?.status || "Charging"
                                }
                                t={t}
                            />
                        </>
                    )}
                </div>
            </BoaterLayout>
        );
    }
}

export default withToast(
    hoistStatics(
        withTranslation()(withRouter(withBoaterStorage(BoaterTransaction))),
        BoaterTransaction,
    ),
);
